import ExtendedSmartComposeInteraction from '../store/schema/ExtendedSmartComposeInteraction';

export default function updateTelemetryForSuggestionOnSuggestionShown(
    suggestionTelemetry: ExtendedSmartComposeInteraction,
    charactersTypedInSession: number,
    numberOfCharactersRendered: number
) {
    const now = new Date();
    suggestionTelemetry.initialRenderTime = now;
    suggestionTelemetry.charactersTypedInSessionAtShownTime = charactersTypedInSession;
    suggestionTelemetry.numberOfCharactersRendered = numberOfCharactersRendered;
}
